'use strict'

import axios from 'axios'

export default axios.create({
  // baseURL: 'https://test.argios.com/api/api/',
  // baseURL: 'https://argios.com/api/api/',
  // baseURL: 'http://localhost:2071/api/',
  baseURL: process.env.VUE_APP_BASE_URL + '/',
  headers: {
    'Content-Type': 'application/json'
  }
})



// WEBPACK FOOTER //
// ./src/axiosr8.js